//changing the youtube and video format to render in iframe
export function videoUrlChange(url: string): string {
  const convertToEmbedUrl = (url: string, platform: string, regex: RegExp, embedUrlFormat: string): string => {
    const match = url.match(regex);
    if (match && match[1]) {
      const videoId = match[1];
      return embedUrlFormat.replace('{videoId}', videoId);
    }
    return url;
  };

  if (url.includes('youtube.com') && !url.includes('youtube.com/embed/')) {
    return convertToEmbedUrl(url, 'youtube', /[?&]v=([^&]+)/, 'https://www.youtube.com/embed/{videoId}');
  }

  if (url.includes('vimeo.com') && !url.includes('player.vimeo.com/video/')) {
    return convertToEmbedUrl(url, 'vimeo', /vimeo.com\/(\d+)/, 'https://player.vimeo.com/video/{videoId}');
  }

  return url;
}
